export const IMAGES_BASE_URL = "https://images.funker530.com/images/media/";
export const IMAGES_BASE_URL_ORIGINAL = "https://images.funker530.com/images/";
export const DEFAULT_THUMBNAIL = "/Funker_Premium_Logo.png";
